<template>
  <q-dialog
    :visible.sync="isVisible"
    title="产品短视频上传"
    width="60%"
    :showFooter="false"
    :innerScroll="false"
    @close="handleClose"
  >
    <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" size="small" class="content">
      <el-form-item label="附件">
        <el-upload
          class="upload-demo"
          ref="upload"
          multiple
          action=""
          :http-request="httpRequest"
          :on-remove="handleRemove"
          :headers="headers"
          :file-list="fileList"
          :on-exceed="masterFileMax"
          :before-upload="beforeUpload"
        >
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button
            style="margin-left: 10px"
            size="small"
            type="success"
            @click="handleUpload"
            :loading="uploading"
          >上传</el-button>
          <div slot="tip" class="el-upload__tip">可以上传所有格式文件，单个文件不能超过300M</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="handleClose">取 消</el-button>
    </div>
  </q-dialog>
</template>

<script>
import { getToken } from '@/utils/auth';

export default {
  name: 'UploadDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    folderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      fileUrlList: [],
      uploading: false,
      formData: {},
      rules: {}
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    handleClose() {
      this.fileList = [];
      this.fileUrlList = [];
      this.uploading = false;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
        this.resetUploadInput();
      }
      this.$emit('update:visible', false);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    httpRequest(file) {},
    masterFileMax(files, fileList) {},
    resetUploadInput() {
      const input = this.$refs.upload && this.$refs.upload.$el.querySelector('input[type="file"]');
      if (input) {
        input.value = '';
      }
    },
    beforeUpload(file) {
      let imgSize = Number(file.size / 1024 / 1024);
      if (imgSize > 300) {
        this.$msgbox({
          title: '',
          message: '上传文件大小不能超过300MB，请重新上传。',
          type: 'warning',
        });
        return false;
      }
      const fileList = this.fileList.filter((item) => item.name !== file.name);
      fileList.push(file);
      this.fileList = fileList;
    },
    getCaption(obj) {
      var index = obj.lastIndexOf('.');
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    getName(obj) {
      var index = obj.lastIndexOf('.');
      obj = obj.substring(0, index);
      return obj;
    },
    handleUpload() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传文件');
        return;
      }
      this.uploading = true;
      this.fileUrlList = [];
      this.fileList.forEach((item, index) => {
        let formDataImport = new FormData();
        this.$refs.upload.submit();
        formDataImport.append('files', item);
        formDataImport.append('appCode', 'ec-pc-new');
        this.uploadFile(formDataImport, item);
      });
    },
    async uploadFile(data, item) {
      this.$q.shortVideoOverview
        .uploadFiles({ data: data })
        .then((res) => {
          if (res.success) {
            this.fileUrlList.push({
              fileExt: this.getCaption(item.name),
              fileName: this.getName(item.name),
              filePath: res.data[0].path,
              fileSize: item.size,
              folderId: this.folderId,
            });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.uploading = false;
        })
        .finally(() => {
          if (this.fileUrlList.length === this.fileList.length) {
            this.submitUpload();
          }
        });
    },
    submitUpload() {
      let data = {
        shortVideoFileDtoList: this.fileUrlList,
      };
      this.$q.shortVideoOverview
        .videoUpload({ data: data })
        .then((res) => {
          if (res.success) {
            this.$message.success('导入成功');
            this.$emit('success');
            this.handleClose();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.fileUrlList = [];
        })
        .finally(() => {
          this.uploading = false;
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 30px 0
.footer
  text-align center
  padding-bottom 10px
.upload-demo
  >>> .el-upload-list
    max-height 300px
    overflow-y auto
</style>
